import { useContext, useState } from "react";
import {
  AuthContext,
  PracticesContext,
  UnitContext,
} from "../../contexts/contextExporter";
import PracticesList from "./PracticesList";
import { ActivePracticeContextProvider } from "../../contexts/ActivePracticeContextProvider";
import { List } from "@phosphor-icons/react";

export default function PracticeMain() {
  const { practices, activePractice, practiceIndex } = useContext(PracticesContext);
  const { unit, isLive, next } = useContext(UnitContext);
  const { isInstructor, user } = useContext(AuthContext);
  const [listOpen, setListOpen] = useState(false);

  const showList = !isLive || isInstructor;

  return (
    <div className="h-full w-full flex overflow-hidden relative">
      {/* Mobile toggle for practice list */}
      {showList && (
        <button
          onClick={() => setListOpen(!listOpen)}
          className="lg:hidden fixed top-14 left-2 z-10 p-2 bg-surface-1 border border-white/[0.08] rounded-lg cursor-pointer text-white/40 hover:text-white/70 transition-colors shadow-lg flex items-center gap-1.5 text-[11px] font-medium"
        >
          <List size={16} />
          <span>{practiceIndex + 1}/{practices.length}</span>
        </button>
      )}

      {/* Practice list sidebar */}
      {showList && (
        <PracticesList
          items={practices}
          userId={user!.id}
          isOpen={listOpen}
          onClose={() => setListOpen(false)}
        />
      )}

      {/* Practice content */}
      <div className="flex-1 transition-all h-full overflow-hidden">
        {activePractice && (
          <ActivePracticeContextProvider
            unitId={unit?.unit_id}
            isLive={isLive}
            practice={activePractice}
          />
        )}
      </div>
    </div>
  );
}
